




import { defineComponent } from '@vue/composition-api';
import ContextProviderRouterView from '@berlin-front/common/components/elements/ContextProviderRouterView';

/**
 * 空っぽの汎用Routeを構成するためのコンポーネント。
 *
 * VueRouterのネストしたルートで親として使用し、通常はここで子と共有するコンテキストプロバイダを設定する。
 * 無闇にグローバルコンテキストを使用せずに、限定された子の間だけでコンテキストを共有できる。
 */
export default defineComponent({
  name: 'AppEmptyRoute',
  components: { ContextProviderRouterView },
});
